(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabath-premium-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSabathCarousels = () => {
      document.querySelectorAll('[data-sabath-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;

        carousel.dataset.initialized = 'true';
        const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
        const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
        const next = carousel.querySelector('[data-carousel-next]');
        const previous = carousel.querySelector('[data-carousel-prev]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let index = 0;
        let timer;

        const setActive = (nextIndex) => {
          index = (nextIndex + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
          });

          dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', String(active));
          });
        };

        const restart = () => {
          if (timer) window.clearInterval(timer);
          if (carousel.dataset.autoplay !== 'true' || reduceMotion) return;

          const speed = Number(carousel.dataset.speed) || 5000;
          timer = window.setInterval(() => setActive(index + 1), speed);
        };

        next?.addEventListener('click', () => {
          setActive(index + 1);
          restart();
        });

        previous?.addEventListener('click', () => {
          setActive(index - 1);
          restart();
        });

        dots.forEach((dot, dotIndex) => {
          dot.addEventListener('click', () => {
            setActive(dotIndex);
            restart();
          });
        });

        carousel.addEventListener('mouseenter', () => timer && window.clearInterval(timer));
        carousel.addEventListener('mouseleave', restart);
        carousel.addEventListener('focusin', () => timer && window.clearInterval(timer));
        carousel.addEventListener('focusout', (event) => {
          if (!carousel.contains(event.relatedTarget)) restart();
        });

        setActive(0);
        restart();
      });
    };

    initSabathCarousels();
    document.addEventListener('shopify:section:load', initSabathCarousels);
  })();

  } catch(e) { console.error(e); }
})();
})();
